<template>
    <popover
        :style="{ left: `${popoverX}px`, top: `${popoverY}px` }"
        :show="show"
        class="flex-header-list"
        @close-popover="$emit('close-popover')"
    >
        <ul>
            <li class="flex-header-list__item">
                <a :href="editUrl(data.id)" class="flex-header-list__link" @click.prevent="navigateUrl">{{ data.name }}</a>
            </li>
            <li v-for="(item, index) in data.children" :key="index" class="flex-header-list__item">
                <a :href="editUrl(item.id)" class="flex-header-list__link" @click.prevent="navigateUrl">{{ item.name }}</a>
            </li>
        </ul>
    </popover>
</template>

<script>
import Popover from '@/components/page-editor/popover';

export default {
    components: {
        Popover,
    },

    props: {
        popoverX: {
            type: Number,
            required: true,
        },

        popoverY: {
            type: Number,
            required: true,
        },

        data: {
            type: Object,
            required: true,
        },

        show: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        editUrl(id) {
            return `/editor/${ id }`;
        },

        navigateUrl(event) {
            this.$emit('close-popover');
            window.location.href = event.currentTarget.getAttribute('href');
        },
    },
};
</script>

<style lang="scss">
.flex-header-list {
    padding: 0px;

    &__item {
        color: var(--form-inputColor);
        background-color: var(--form-inputBackgroundColor);
        font-size: 12px;

        &:hover {
            cursor: pointer;
            color: var(--form-inputHoverColor);
            background-color: var(--form-inputHoverBackgroundColor);
        }

        &:not(:first-of-type) {
            border-top: 1px solid var(--form-inputBorderColor);
        }
    }

    &__link {
        display: block;
        padding: 10px 40px 10px 15px;
    }
}

</style>
